import React from 'react'

const AnnouncementsHeader = () => (
  <div className='relative basis-auto shrink-0 grow-0'>
    <div>
      <div className='bt-thick bt--dark-cerulean' />
    </div>
  </div>
)

export default AnnouncementsHeader
